// extracted by mini-css-extract-plugin
export default {"introPageContainer":"introPage_introPageContainer__mvKvA","introPageLeft":"introPage_introPageLeft__2W3uK","introPageRight":"introPage_introPageRight__dTggY"};